'use strict';

if (!Symbol.species) {
    Symbol.species = Symbol.for('@@species');
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-curve-fitting/~/ml-matrix/src/symbol-species.js
// module id = 136
// module chunks = 0